<template>
  <section
    :id="id"
    :class="['cac-page', { 'cac-page--has-sidebar': hasSidebar }, id]"
    :aria-labelledby="headerId"
  >
    <slot name="pre-content"/>
    
    <div class="cac-page__content row">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "CACPage",
  props: {
    hasSidebar: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      // For use in CACPageHeader
      pageHeaderId: this.headerId
    };
  },
  computed: {
    id() {
      return `cac-page--${this.$route.name}`;
    },
    headerId() {
      return `${this.id}-header`;
    }
  }
};
</script>
